import React from 'react'
import GenericGrid from '../../../sharedcomponents/5templates/commonGrid/GenericGrid'
import GridWrapper from '../../../sharedcomponents/5templates/commonGrid/GridWrapper'
import useGridWrapper from '../../../sharedcomponents/5templates/commonGrid/useGridWrapper'
import useSkillset from './useSkillset'
import { pageVars } from '../../../pages/const/pageVars'

const {codeText, headerText, showWarning, } = pageVars.SKILLSETS

const pageSettings = {
  showWarning: showWarning || false,
  codeText: codeText || 'pageCodeText',
  headerText: headerText || 'pageHeaderText',
}


const SkillsetSummary = () => {
  const defaultFetchParameter = {
    sort: '+name',
    page: 0,
    per_page: 20
  }
  const { loadSkillsets, bulkUpdateSkillsetsCallBack } = useSkillset()

  const {
    editMode,
    setEditMode,
    isSnackbarOpen,
    setIsSnackbarOpen,
    deletionChanges,
    deleteCallBack,
    activationChanges,
    activationCallBack,
    detailCallBack,
    addCallBack,
    handSaveCallback,
    isGridDirty
  } = useGridWrapper(
    pageSettings.codeText,
    bulkUpdateSkillsetsCallBack,
    pageSettings.showWarning
  )

  const visibleColumns = [
    { field: 'name', headerName: 'Name', width: 250, sortable: true },
    { field: 'description', headerName: 'Description', width: 400, sortable: true },
    {
      field: 'active',
      headerName: 'Status',
      width: 200,
      sortable: true,
      isToggle: true
    }
  ]

  const fetchCallBack = async arg => {
    const {
      data: { data, pagination, sort } = {
        data: [],
        pagination: {},
        sort: {}
      },
      isError,
      isLoading,
      isFetching
    } = await loadSkillsets(arg)
    // transform the server-provided array for display
    const rows = []
    data.forEach(one => {
      rows.push({
        id: one.id, //please note, the underlying datagrid assumes the id column is always called id
        name: one.name,
        description: one.description,
        active: one.suspended_at ? false : true
      })
    })

    return {
      newRows: rows,
      newPagination: pagination,
      newSort: sort,
      newLoading: isLoading || isFetching,
      newError: isError
    }
  }

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div style={{ height: '100%', width: '100%' }}>
        <GridWrapper
          header={pageSettings.headerText}
          containedEntityType={'NA'}
          editMode={editMode}
          setEditMode={setEditMode}
          isSnackbarOpen={isSnackbarOpen}
          setIsSnackbarOpen={setIsSnackbarOpen}
          isGridDirty={isGridDirty}
          addCallBack={addCallBack}
          handleSave={handSaveCallback}
        >
          <GenericGrid
            pageCodeText={pageSettings.codeText}
            initialFetchParameters={defaultFetchParameter}
            visibleColumns={visibleColumns}
            editMode={editMode}
            fetchCallBack={fetchCallBack}
            detailCallBack={detailCallBack}
            deleteCallBack={deleteCallBack}
            activationCallBack={activationCallBack}
            deletionChanges={deletionChanges}
            activationChanges={activationChanges}
            showWarning={pageSettings.showWarning}
          />
        </GridWrapper>
      </div>
    </div>
  )
}
export default SkillsetSummary
